import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseLayerComponent } from './base-layer.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [BaseLayerComponent],
  exports: [BaseLayerComponent]
})
export class BaseLayerModule { }
